import { combineEpics } from 'redux-observable';
import computeDetailEpic from './ComputeDetailEpic';
export const rootEpic = combineEpics(computeDetailEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
